/**
 * Carrusel testimonios — slides fijos 550px, scroll horizontal + puntos.
 */
(function () {
  function init(root) {
    var viewport = root.querySelector('[data-oleum-testimonials-viewport]');
    var track = root.querySelector('[data-oleum-testimonials-track]');
    var dotsWrap = root.querySelector('[data-oleum-testimonials-dots]');
    if (!viewport || !track || !dotsWrap) return;

    var slides = track.querySelectorAll('[data-oleum-testimonials-slide]');
    if (slides.length === 0) return;

    function slideLeft(index) {
      var el = slides[index];
      return el ? el.offsetLeft : 0;
    }

    function updateDots() {
      var scrollL = viewport.scrollLeft;
      var active = 0;
      var best = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slideLeft(i) - scrollL);
        if (d < best) {
          best = d;
          active = i;
        }
      }
      var dots = dotsWrap.querySelectorAll('.oleum-testimonials__dot');
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === active);
        dot.setAttribute('aria-selected', j === active ? 'true' : 'false');
      });
      if (slides.length > 1) {
        dotsWrap.removeAttribute('hidden');
        dotsWrap.setAttribute('aria-hidden', 'false');
      } else {
        dotsWrap.setAttribute('hidden', '');
        dotsWrap.setAttribute('aria-hidden', 'true');
      }
    }

    function scrollToIndex(i) {
      if (i < 0 || i >= slides.length) return;
      viewport.scrollTo({ left: slideLeft(i), behavior: 'smooth' });
    }

    var analyticsPrefix = (root.getAttribute('data-oleum-testimonials-analytics-prefix') || 'inicio').trim() || 'inicio';
    var dotAriaPrefix = (root.getAttribute('data-oleum-testimonials-dot-aria-prefix') || 'Testimonio').trim() || 'Testimonio';

    if (!dotsWrap.hasChildNodes()) {
      slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oleum-testimonials__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', dotAriaPrefix + ' ' + (i + 1));
        btn.setAttribute('data-eventoclick', analyticsPrefix + '_testimonios_punto_' + (i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.setAttribute('role', 'tab');
        btn.addEventListener('click', function () {
          scrollToIndex(i);
        });
        dotsWrap.appendChild(btn);
      });
    }

    var t;
    viewport.addEventListener(
      'scroll',
      function () {
        clearTimeout(t);
        t = setTimeout(updateDots, 80);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(t);
        t = setTimeout(updateDots, 120);
      },
      { passive: true }
    );

    updateDots();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-oleum-testimonials-root]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
